import React, { useState,useEffect } from "react";
import SideBar from "../Sidebar";
import Header from "../Header";

const Layout = ({ children }) => {
    const [isSidebarOpen, setIsSidebarOpen] = useState(true);

    const toggleNav = () => {
        setIsSidebarOpen(prevState => !prevState);
    };

    useEffect(() => {
        const container = document.getElementById("container");
        if (isSidebarOpen) {
            container.classList.add("sidebar-open");
        } else {
            container.classList.remove("sidebar-open");
        }
    }, [isSidebarOpen]);

    return (
        <div id="container" className="container-fluid position-relative d-flex p-0">
            <div id="mySidebar" className="sidebar">
                <SideBar />
            </div>

            <div id="main" className="content">
                <Header toggleNav={toggleNav} />
                {children}
            </div>
        </div>
    )
}

export default Layout;